module.exports = __webpack_public_path__ + "static/img/code2.48c8dcf.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/code2.png
// module id = Cvma
// module chunks = 1